import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import CardHeader from '@material-ui/core/CardHeader';
import {
  CircularProgress,
  Divider,
  TextField,
  Typography,
} from '@material-ui/core';
import moment from 'moment';
import swal from 'sweetalert';
import firebase from '../../../config/config';
import apiCaller from '../../../utils/apiCallerOutstanding';
import { mappedCurrentActiveRole } from '../../../utils/roleMapping';
import { filterComment } from '../../../utils/regexValidator';

const buttonStyles = {
  background: '#3366FF',
  color: 'white',
  fontSize: '12px',
  textTransform: 'capitalize',
  marginLeft: '20px',
};
const useStyles = makeStyles({
  root: {
    minWidth: 275,
    marginTop: '10px',
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 2,
  },
  commentbox: {
    maxHeight: '300px',
    overflowY: 'scroll',
    scrollbarWidth: 'thin',
    padding: '10px',
  },
});

export default function OutlinedCard({ truckerData, activeRole, refetch }) {
  const [submitting, setSubmitting] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [comment, setComment] = useState('');
  const classes = useStyles();

  const commentsData = truckerData?.comment_list || [];

  const currentActiveRole = mappedCurrentActiveRole(activeRole);

  const submitComment = async () => {
    setSubmitting(true);
    setFetching(true);
    const userDetails = firebase.auth().currentUser;
    const { Aa } = userDetails;
    const endPoint = 'trips/add-comments';
    const body = {
      type: 'truckers',
      comment,
      channel_id: truckerData?.trucker_id,
      role: currentActiveRole,
    };
    await apiCaller(endPoint, body, `Bearer ${Aa}`, 'nh-base', 'post')
      .then(response => {
        setSubmitting(false);
        setComment('');
        setFetching(false);
        refetch();
      })
      .catch(error => {
        swal('Error!', `Something went wrong`, 'error');
        setSubmitting(false);
        setFetching(false);
      });
  };

  const handleSubmitOnPress = e => {
    if (e.key === 'Enter' && comment !== '') {
      // Cancel the default action, if needed
      e.preventDefault();
      // Trigger the button element with a click
      submitComment();
    }
  };
  const handleTextChange = e => {
    const filteredComment = filterComment(e.target.value);
    setComment(filteredComment);
    if (e.key === 'Enter') {
      // Cancel the default action, if needed
      e.preventDefault();
      // Trigger the button element with a click
      submitComment();
    }
  };
  return (
    <Card className={classes.root}>
      <CardHeader style={{ padding: '10px' }} title="Comments" />
      <Divider />
      {fetching ? (
        <CircularProgress size={20} />
      ) : (
        <CardContent className={classes.commentbox}>
          {commentsData?.length === 0 ? (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
              }}
            >
              <Typography
                className={classes.title}
                color="textSecondary"
                gutterBottom
              >
                No Comments Available
              </Typography>
            </div>
          ) : null}
          {commentsData?.length > 0 ? (
            <div style={{ margin: '10px' }}>
              {commentsData?.map(commentDetail => (
                <div
                  style={{ marginBottom: '20px' }}
                  key={commentDetail?.commented_at}
                >
                  <Typography className={classes.pos}>
                    {commentDetail?.comment}
                  </Typography>
                  <Typography
                    variant="caption"
                    display="block"
                    gutterBottom
                    color="textSecondary"
                  >
                    {commentDetail?.commented_by}
                    &nbsp; &nbsp; &nbsp;
                    {moment(commentDetail?.commented_at).format('DD-MM-YYYY')}
                    &nbsp;
                    {moment(commentDetail?.commented_at).format('hh:mm A')}
                  </Typography>
                </div>
              ))}
            </div>
          ) : null}
        </CardContent>
      )}
      {activeRole !== 'finance' &&
        activeRole !== 'finance-payable' &&
        activeRole !== 'finance-recievable' &&
        activeRole !== 'finance-recon' &&
        activeRole !== 'partner-exec-manager' &&
        !truckerData?.blacklist && (
          <CardActions>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                margin: '20px',
              }}
            >
              <TextField
                fullWidth
                id="standard-basic"
                label="Add Comment"
                value={comment}
                onKeyDown={handleSubmitOnPress}
                onChange={handleTextChange}
              />
              {submitting ? (
                <CircularProgress size={20} />
              ) : (
                <Button
                  size="small"
                  variant="contained"
                  style={buttonStyles}
                  onClick={submitComment}
                  disabled={comment === ''}
                >
                  Submit
                </Button>
              )}
            </div>
          </CardActions>
        )}
    </Card>
  );
}
